import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL, // Dynamically loaded from environment variables
  withCredentials: true, // Ensure credentials like cookies are sent if needed
});

export default axiosInstance;
